import React, { useContext } from 'react';
// eslint-disable-next-line yola/import/no-extraneous-dependencies
import { FloatingArrow, FloatingPortal } from '@floating-ui/react';
import classNames from 'classnames';
import PopoverContext from '../../context';
import Paragraph from '../../../paragraph';
import getTextAppearances from './helpers/get-text-appearances';
import { APPEARANCES } from '../../constants';

const PopoverContent = ({ children = null, className = '' }) => {
  const {
    // @ts-ignore TS(2339): Property 'isVisible' does not exist on type '{}'.
    isVisible,
    // @ts-ignore TS(2339): Property 'title' does not exist on type '{}'.
    title,
    // @ts-ignore TS(2339): Property 'description' does not exist on type '{}'... Remove this comment to see the full error message
    description,
    // @ts-ignore TS(2339): Property 'width' does not exist on type '{}'.
    width,
    // @ts-ignore TS(2339): Property 'hotkey' does not exist on type '{}'.
    hotkey,
    // @ts-ignore TS(2339): Property 'appearance' does not exist on type '{}'.
    appearance,
    // @ts-ignore TS(2339): Property 'imgSrc' does not exist on type '{}'.
    imgSrc,
    // @ts-ignore TS(2339): Property 'refs' does not exist on type '{}'.
    refs,
    // @ts-ignore TS(2339): Property 'floatingStyles' does not exist on type '... Remove this comment to see the full error message
    floatingStyles,
    // @ts-ignore TS(2339): Property 'arrowRef' does not exist on type '{}'.
    arrowRef,
    // @ts-ignore TS(2339): Property 'context' does not exist on type '{}'.
    context,
    // @ts-ignore TS(2339): Property 'getFloatingProps' does not exist on type... Remove this comment to see the full error message
    getFloatingProps,
  } = useContext(PopoverContext);

  if (!isVisible) {
    return null;
  }

  const classes = classNames(
    'ws-ui-popover-content',
    `ws-ui-popover-content--${appearance}`,
    className
  );

  const { titleAppearance, hotkeyAppearance, descriptionAppearance } = getTextAppearances(
    title,
    appearance
  );

  return (
    <FloatingPortal>
      <div
        ref={refs.setFloating}
        className={classes}
        style={{ ...floatingStyles, width }}
        {...getFloatingProps()}
      >
        {imgSrc && <img src={imgSrc} className="ws-ui-popover-content__img" alt="" />}
        {title && (
          <div className="ws-ui-popover-content__header">
            <div className="ws-ui-popover-content__title">
              <Paragraph appearance={titleAppearance}>
                <b>{title}</b>
              </Paragraph>
            </div>
            {hotkey && (
              <div className="ws-ui-popover-content__hotkey">
                <Paragraph size="small" appearance={hotkeyAppearance}>
                  {hotkey}
                </Paragraph>
              </div>
            )}
          </div>
        )}
        {description && (
          <Paragraph size="small" appearance={descriptionAppearance}>
            {description}
          </Paragraph>
        )}

        {children}
        <FloatingArrow
          ref={arrowRef}
          context={context}
          strokeWidth={1}
          height={5}
          width={10}
          fill="var(--bg-color)"
          {...(appearance === APPEARANCES.light && { stroke: 'var(--border-color)' })}
        />
      </div>
    </FloatingPortal>
  );
};

export default PopoverContent;
